import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SharedModule} from './shared-module/shared.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PrintModule} from './print-module/print.module';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        SharedModule,
        BrowserAnimationsModule
    ],
    exports: [],
    bootstrap: [AppComponent]
})
export class AppModule {
}
